import type { ApiError } from '@common/api/graphql/apolloClient';
import type {
  DownloadUrl,
  RequestBulkDeliverableUrlResponse
} from '../../../../common/api/graphql/requestBulkDeliverableUrlGql';
import { requestBulkDeliverableUrl } from '../../../../common/api/graphql/requestBulkDeliverableUrlGql';
import {
  requestBulkDeliverableUrlFailure,
  requestBulkDeliverableUrlStart,
  requestBulkDeliverableUrlSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';
import handleApiErrorIfNeeded from './handleApiErrorIfNeeded';

const requestBulkDeliverableUrlSuccessThunk =
  (
    response: RequestBulkDeliverableUrlResponse
  ): AppThunkAction<Promise<string>> =>
  dispatch => {
    const { downloadUrl } = response.data!.requestBulkDeliverableUrl;
    dispatch(requestBulkDeliverableUrlSuccess());
    return Promise.resolve(downloadUrl);
  };

export const requestBulkDeliverableUrlFailureThunk =
  (error: ApiError): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(requestBulkDeliverableUrlFailure());
    return dispatch(handleApiErrorIfNeeded(error));
  };

export const requestBulkDeliverableUrlThunk =
  (
    urlCode: string,
    downloadType: string
  ): AppThunkAction<Promise<DownloadUrl | void>> =>
  dispatch => {
    dispatch(requestBulkDeliverableUrlStart());

    return requestBulkDeliverableUrl(urlCode, downloadType)
      .then((response: RequestBulkDeliverableUrlResponse) =>
        dispatch(requestBulkDeliverableUrlSuccessThunk(response))
      )
      .catch(error => dispatch(requestBulkDeliverableUrlFailureThunk(error)));
  };
